import { Routes, Route } from 'react-router-dom';
import React from 'react';
import MyForms from './CommonComponents/MyForms';
import PublishedForms from './CommonComponents/PublishedForms';
import FormsSubmitted from './CommonComponents/FormsSubmitted';
import FormsShared from './CommonComponents/FormsShared';
import AdminDashboard from './AdminComponents/AdminDashboard';
import FormCategories from './AdminComponents/FormCategories';
import FormCategory from './AdminComponents/ViewCategory';
import JobCategories from './AdminComponents/JobCategories';
import ErrorLogs from './AdminComponents/ErrorLogs';
import Users from './AdminComponents/Users';
import Settings from './AdminComponents/Settings';
import InternalErrorPage from './InternalErrorPage';
import FormMasters from './FormDesignerComponents/FormMasters';
import FormMastersView from './FormDesignerComponents/FormMasterView';
import FormViews from './FormDesignerComponents/FormViews';
import FormMastersForApprover from './FormApproverComponents/FormMastersForApprover';
import FormPreviewPage from './CommonComponents/FormMasterPreviewPage';
import FormView from './CommonComponents/FormView';
function Home() {
  const user = JSON.parse(localStorage.getItem('user'));

  return (
    // <div style={{ height: '100%'}}>
      <div className="content-wrapper" style={{minHeight:'88%'}}>     
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-1">
            <div class="col-sm-6">
                <h1></h1>
            </div>
        </div>
    </div>
    {/* <!-- /.container-fluid --> */}
</section>
        <section className="content">

          <div className="container-fluid" style={{ padding: '0' }}>
            <Routes>
              {user && user.isAdmin && (
                <>
                  <Route path="admindashboard" element={<AdminDashboard />} />
                  <Route path="FormCategories" element={<FormCategories />} />
                  <Route path="JobCategories" element={<JobCategories />} />
                  <Route path="ErrorLogs" element={<ErrorLogs />} />
                  <Route path="Settings" element={<Settings />} />
                  <Route path="Users" element={<Users />} />
                  <Route path="/form-preview" element={<FormPreviewPage/>} />
                </>
              )}
              
              {user && user.isFormDesigner && (
                <>
                  {/* Add designer-specific routes here */}
                  <Route path="FormMasters" element={<FormMasters />} />
                  <Route path="FormMastersView/:id" element={<FormMastersView />} />
             <Route path="FormViews/:id" element={<FormViews />} />
                  <Route path='FormView' element={<FormView/>}/>
                </>
              )}
              {user && user.isFormApprover && (
                <>
                  {/* Add Approver-specific routes here */}
                  <Route path="FormMastersForApprover" element={<FormMastersForApprover />} />
                  <Route path="/form-preview" element={<FormPreviewPage/>} />
                </>
              )}
               
              <Route path="MyForms" element={<MyForms />} />
              <Route path="PublishedForms" element={<PublishedForms />} />
              <Route path="FormsSubmitted" element={<FormsSubmitted />} />
              <Route path="FormsShared" element={<FormsShared />} />
              <Route path="FormCategory/:id" element={<FormCategory />} />
              <Route path="Internalerrorpage" element={<InternalErrorPage />} />
              <Route path="/form-preview/:id" element={<FormView />} />   

            </Routes>
          </div>
        </section>
      </div>

  );
}

export default Home;
